import request from '@/utils/request'

/**
 * 调剂核查证列表
 * @param {*} data 
 * @returns 
 */
export const getTJHCList = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/tjz/list`,
    data: data
})

/**
 * 新增调剂核查证
 * @param {*} data 
 * @returns 
 */
export const addTJHC = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/tjz/add`,
    data: data
})

/**
 * 查询调剂核查证
 * @param {*} data 
 * @returns 
 */
export const getTJHC = (id) => request({
    method: 'get',
    url: `/yzdservice/api/enterprise/tjz/detail/${id}`
})

/**
 * 编辑调剂核查证
 * @param {*} data 
 * @returns 
 */
export const updateTJHC = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/tjz/edit`,
    data
})

/**
 * 删除调剂核查证
 * @param {*} data 
 * @returns 
 */
export const deleteTJHC = (id) => request({
    method: 'delete',
    url: `/yzdservice/api/enterprise/tjz/delete/${id}`
})
/**
 * 删除调剂核查证图片
 * @param {*} id 
 * @returns 
 */
export const deleteTJHCImage = (id) => request({
    method: 'delete',
    url: `/yzdservice/api/enterprise/tjz/deletefile/${id}`
})

/**
 * 核销调剂核查证
 * @param {*} id 
 * @returns 
 */
export const writeOffTJHC = (id) => request({
    method: 'put',
    url: `/yzdservice/api/enterprise/tjz/WriteOff/${id}`
})
/**
 * 取消核销调剂核查证
 * @param {*} id 
 * @returns 
 */
export const cancelWriteOffTJHC = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/tjz/cancelWriteOff`,
    data
})

/**
 * 证书审批详情
 * @param {*} id 
 * @returns 
 */
export const getCredentials = (id) => request({
    method: 'get',
    url: `/yzdservice/api/enterprise/credentials/common/splc/${id}`
})

/**
 * 导出
 * @param {*} id 
 * @returns 
 */
export const excelwriter = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/tjz/excelwriter`,
    data,
    responseType: 'blob'
})

/**
 * 手动录入
 * @param {*} data
 * @returns 
 */
 export const manualEntry = (data) => request({
    method: 'post',
    url: `/yzdservice/api/enterprise/tjz/record`,
    data
})

